import { FC } from 'react';

import { IcShareScreen16Icon } from '@gem/icons';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import {
  IShareScreenButtonPresenterParams,
  useShareScreenButtonPresenter,
} from './ShareScreenButton.presenter';

interface IShareScreenButtonProps extends IShareScreenButtonPresenterParams {
  className?: string;
  isDisabled: boolean;
}

export const ShareScreenButton: FC<IShareScreenButtonProps> = ({
  className,
  isDisabled,
  isActive,
  shareScreen,
  stopSharingScreen,
}) => {
  const { isProcessing, onClick } = useShareScreenButtonPresenter({
    isActive,
    shareScreen,
    stopSharingScreen,
  });

  return (
    <IconButton
      className={className}
      Icon={IcShareScreen16Icon}
      size={IconViewSizes.Big}
      iconSize={IconViewSizes.Medium}
      theme={isActive ? '13' : '12'}
      isDisabled={isDisabled}
      isLoading={isProcessing}
      onClick={onClick}
    />
  );
};
